<div>
    <mat-stepper labelPosition="bottom" class="example-stepper" [orientation]="(stepperOrientation | async)!"
        style="margin:20px" *ngIf="resposive">
        <mat-step>
            <ng-template matStepLabel>{{"Choisir le véhicule"}}</ng-template>
            <ng-template matStepContent>
                <div fxLayout="row" fxLayoutAlign="start end end">
                    <div fxFlex="50"></div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperNext  color="primary" style="float:right">
                            <mat-icon>
                                arrow_forward
                            </mat-icon>
                        </button>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center">
                    <mat-form-field fxFlex="100" fxFlex.gt-sm="100">
                        <mat-label>Vehicule</mat-label>
                        <mat-select placeholder="choisir un vehicule" name="vehicule" [(ngModel)]="vehicule" required
                            (selectionChange)="resevationVehicule()">
                            <mat-option *ngFor="let item of Car" [value]="item.id">
                                {{item.vehicle_mark}},{{item.vehicle_model}}
                            </mat-option>
                        </mat-select>
                        <mat-hint>Champs Obligatoire *</mat-hint>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start end end" *ngIf="resposive =='vertical'">
                    <div fxFlex="50"></div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperNext  color="primary" style="float:right">
                            <mat-icon>
                                arrow_forward
                            </mat-icon>
                        </button>
                    </div>
                </div>
            </ng-template>
        </mat-step>
        <mat-step *ngIf="rentings.length !=0">
            <ng-template matStepLabel>{{"Choisir une Reservation"}}</ng-template>
            <ng-template matStepContent>
                <div fxLayout="row" fxLayoutAlign="start end end">
                    <div fxFlex="50"></div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperNext  color="primary" style="float:right">
                            <mat-icon>
                                arrow_forward
                            </mat-icon>
                        </button>
                        <button mat-icon-button matStepperPrevious  style="float:right">
                            <mat-icon>
                                arrow_back
                            </mat-icon>
                        </button>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center">
                    <mat-form-field fxFlex="100" fxFlex.gt-sm="100">
                        <mat-label>Reservation</mat-label>
                        <mat-select placeholder="choisir un vehicule" name="reservation" [(ngModel)]="renting"
                            (selectionChange)="loadElementConstat()" required>
                            <mat-option>
                                <span style="margin-right:5px;font-weight: bloder">Date de départ</span>
                                <span style="margin-left:25px;font-weight: bloder">Date de retour </span>
                            </mat-option>

                            <mat-option *ngFor="let reservation of rentings" [value]="reservation">
                                <span style="margin-right:5px">{{reservation.renting_date_departure
                                    |date:'mediumDate'}}</span>
                                <span style="margin-left:26px">{{reservation.renting_date_return |date:'mediumDate'}}
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-hint>Champs Obligatoire *</mat-hint>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start end end" style="margin:20px" *ngIf="resposive =='vertical'">
                    <div fxFlex="50"></div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperNext  color="primary" style="float:right">
                            <mat-icon>
                                arrow_forward
                            </mat-icon>
                        </button>
                        <button mat-icon-button matStepperPrevious  style="float:right">
                            <mat-icon>
                                arrow_back
                            </mat-icon>
                        </button>
                    </div>
                </div>
            </ng-template>
        </mat-step>
        <mat-step *ngFor="let element of constat; let i=index; let first = first; let last = last"
            [ngStyle]="{'display':(renting!=null)?'block':'none'}">
            <ng-template matStepLabel style="text-align:center"
                *ngIf="constat.length<=5 || resposive =='vertical'">{{element.name}}</ng-template>
            <ng-template matStepContent>
                <mat-toolbar *ngIf="constat.length>5 && resposive !='vertical'">
                    <span>{{element.name}}</span>
                </mat-toolbar>

                <div fxLayout="row" fxLayoutAlign="start end end" style="margin-right:20px;  margin-top:50px">
                    <div fxFlex="50">
                        <button mat-flat-button (click)="drop.showFileSelector()" color="primary"
                            style="margin-left:15px;" *ngIf="element.file.length>0">Ajouter</button>
                        <button mat-flat-button (click)="onRemoveAll(i)"
                            style="margin-left:15px;background-color: grey !important;color:white !important">Effacer</button>
                    </div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperNext  color="primary" style="float:right">
                            <mat-icon>
                                arrow_forward
                            </mat-icon>
                        </button>
                        <button mat-icon-button matStepperPrevious  style="float:right">
                            <mat-icon>
                                arrow_back
                            </mat-icon>
                        </button>

                    </div>

                </div>
                <div fxLayout="row" fxLayoutAlign="start end" style="margin-top:25px" *ngIf="showMessage">
                    <div fxFlex="100" style="margin:20px">
                        <h4>Cliquez dans le cadre ou sur le bouton *Ajouter* ci-dessus pour ajouter une nouvelle image</h4>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start end" style="margin-top:25px">
                    <ngx-dropzone #drop (change)="onSelect($event,i)" [maxFileSize]="5072000"
                        [disableClick]="element.file.length>=1?true:false" name="file" fxFlex="100" name="file"
                        [ngStyle]="onCheckFile(i)?{'border':'2px dashed rgb(235,79,79)'}:{}">
                        <ngx-dropzone-label>
                            <button mat-icon-button color="primary">
                                <mat-icon>file_upload</mat-icon>
                            </button>
                            <h5 style="color:red">Inserez au moins une Image *</h5>
                            <h6>Taille Maximal du fichier: 5Mo</h6>
                            <h6>Maximun: 5 images</h6>

                        </ngx-dropzone-label>

                        <div *ngFor="let f of element.file; let z=index;let zlast = last"
                            style="width:200px;text-align:center;font-size:15px;">
                            <ngx-dropzone-image-preview class="image-drop" ngProjectAs="ngx-dropzone-preview" [file]="f"
                                [removable]="true" (removed)="onRemove(f,i)" (click)="seeFile(f,i)">
                            </ngx-dropzone-image-preview>
                            <span class="dzlabel">Image {{z+1}}</span>
                        </div>
                    </ngx-dropzone>
                </div>
                <div fxLayout="row" fxLayoutAlign="start end" style="margin-top:50px">
                    <mat-form-field appearance="fill" fxFlex="100" style="margin-right:20px;margin-bottom: -8px">
                        <mat-label>Commentaire</mat-label>
                        <textarea matInput style="height: 150px;" name="commentaire"
                            [(ngModel)]="element.commentValue"></textarea>
                        <mat-hint>
                            Ce champs n'est pas obligatoire !
                        </mat-hint>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="start" style="margin:20px" *ngIf="resposive !='vertical'">
                    <button mat-icon-button matStepperNext  color="primary" style="float:right">
                        <mat-icon>
                            arrow_forward
                        </mat-icon>
                    </button>
                    <button mat-icon-button matStepperPrevious  style="float:right">
                        <mat-icon>
                            arrow_back
                        </mat-icon>
                    </button>
                </div>

            </ng-template>
        </mat-step>
        <mat-step *ngIf="constat && totalElementConstat==0">
            <ng-template matStepLabel style="text-align:center"
            *ngIf="constat.length<=5 || resposive =='vertical'">{{"Signature"}}</ng-template>
            <ng-template matStepContent>
                <mat-toolbar *ngIf="constat.length>5 && resposive !='vertical'">
                    <span>{{"Signature Electronique"}}</span>
                </mat-toolbar>
                <div fxLayout="row" fxLayoutAlign="start end end">
                    <div fxFlex="50"></div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperPrevious  style="float:right">
                            <mat-icon>
                                arrow_back
                            </mat-icon>
                        </button>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center">
                    <button mat-flat-button color="warn" style="margin:15px" (click)="cleanSignature()">Effacer</button>
                    <button mat-flat-button color="primary" style="margin:15px" (click)="voirContrat()"> <mat-icon>receipt_long</mat-icon> Voir le Contrat </button>
                </div>
                <div fxLayout="row" fxLayoutAlign="center">
                    <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>
                </div>
                <div fxLayout="row" fxLayoutAlign="start end end" *ngIf="resposive =='vertical'">
                    <div fxFlex="50"></div>
                    <div fxFlex="50">
                        <button mat-icon-button matStepperPrevious  style="float:right">
                            <mat-icon>
                                arrow_back
                            </mat-icon>
                        </button>
                    </div>
                </div>                
            </ng-template>
        </mat-step>
    </mat-stepper>

    <div fxLayout="row" fxLayoutAlign="center center">
        <button mat-flat-button color="warn" style="margin:15px" (click)="annuler()">Annuler</button>
        <button mat-flat-button color="primary" style="margin:15px" (click)="onSubmitConstat()"
            [disabled]="totalElementConstat==null || totalElementConstat==undefined || totalElementConstat!=0 ||signatureImg==undefined ||signatureImg==null ">Enregister</button>
    </div>
</div>